import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text/text';
import type {TogglerTabProps} from './toggler-tab.types';
import styles from '@FormMakerReact/layout/form-maker-form-toggler/form-maker-form-toggler.module.scss';

export function TogglerTab({isActive, icon, label, onClick}: TogglerTabProps): ReactElement {
  return (
    <button type="button" role="radio" aria-checked={isActive} className={`${styles.tab} ${isActive ? styles.active : ''}`} onClick={onClick}>
      <Icon icon={icon} size={IconSize.SIZE_ICON_16} />
      <Text val={label} size={TextSize.MD} bold />
    </button>
  );
}
